import { useRef } from "react";
import { CameraContext, useCamera } from "../../../../utilities/camera";

export interface CameraProviderProps {
  children: React.ReactNode;
}

/**
 * Provides the camera context and permissions, ensures permissions are granted before rendering children
 */
export function CameraProvider({ children }: CameraProviderProps) {
  const contextValue = useCamera();
  const mediaStream = useRef<MediaStream>();

  return (
    <CameraContext.Provider value={{ ...contextValue, mediaStream }}>
      {children}
    </CameraContext.Provider>
  );
}
